<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
  >
    <div>
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="知识点名称:" :required="true">
              <el-input
                v-model="form.name"
                :disabled="form.provincialExamination == '1'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省考标识:">
              <el-checkbox
                v-model="form.provincialExamination"
                :disabled="true"
                true-label="1"
                false-label="0"
              ></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="知识点描述:">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item
          label="维护单位:"
          style="display: inline-block; width: 50%"
        >
          <el-input v-model="form.company" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="创建人:" style="display: inline-block; width: 50%">
          <el-input v-model="form.user" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: center"
    >
      <el-button type="primary" @click="keepAdd" v-if="!isEdit">保存</el-button>
      <el-button @click="goBack">返回</el-button>
      <el-button type="primary" v-if="isEdit" @click="keepAdd"
        >保存修改</el-button
      >
      <!-- <el-button type="primary" v-show="status2">新增</el-button> -->
      <el-button type="" v-if="isEdit" @click="del">删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
export default {
  name: 'KnowledgeAdd',
  components: {},
  inject: ['reload'],
  props: ['courseName', 'courseWareId'],
  data() {
    return {
      status1: false,
      status2: false,
      status3: false,
      isEdit: false,
      loading: false,
      dialogVisible: false,
      form: {
        name: '',
        desc: '',
        provincialExamination: '0',
        company: '',
        user: '',
        institutionId: '',
      },
      id: '',
      title: '',
      userType: '',
    }
  },
  methods: {
    // 初始化
    init(id) {
      this.isEdit = false
      this.dialogVisible = true
      if (id == '' || id == undefined || id == null) {
        this.title = `《${this.courseName}》知识点新增`
      } else {
        this.isEdit = true
        this.id = id
        this.title = `《${this.courseName}》知识点查看`
        this.viewKnowledge(this.id)
      }
    },
    // 获取数据
    getList() {
      this.getUserByUid()
      this.getSchoolByUid()
    },

    // 通过uid获取用户
    getUserByUid() {
      let uid = this.getUId
      api.getUserByUid(uid).then(({ data }) => {
        if ((data.code = 100000)) {
          data = data.data
          this.form.user = data.uname
          this.userType = data.type
        }
      })
    },

    // 通过uid获取机构
    getSchoolByUid() {
      let uid = this.getUId
      api.getSchoolByUid(uid).then(({ data }) => {
        if ((data.code = 100000)) {
          data = data.data
          this.form.company = data.title
          this.form.institutionId = data.id
        }
      })
    },

    viewKnowledge(id) {
      api.viewKnowledge(id).then(({ data }) => {
        if ((data.code = 100000)) {
          data = data.data
          for (let i = 0; i < data.length; i++) {
            this.form.name = data[i].knowledgeName
            this.form.desc = data[i].knowledgeDescription || ''
            this.form.provincialExamination = data[i].provincialExamination
          }
        }
      })
    },

    handleClose() {
      this.dialogVisible = false
      this.$emit('closeAddDialog')
      // this.form.name = ''
      // this.form.desc = ''
    },

    keepAdd() {
      if (
        this.form.name == '' ||
        this.form.name == undefined ||
        this.form.name == null
      ) {
        this.$message({ type: 'error', message: `请输入知识点名称` })
        return
      } else {
        let formData = new FormData()
        formData.append('knowledgeName', this.form.name)
        formData.append('knowledgeDescription', this.form.desc)
        formData.append(
          'provincialExamination',
          this.form.provincialExamination
        )
        formData.append('id', this.id)
        formData.append('institutionId', this.form.institutionId)
        formData.append('createId', this.getUId)
        const courseWareId = this.courseWareId || this.$route.query.id
        formData.append('courseWareId', courseWareId)
        api.addKnowledge(formData).then(({ data }) => {
          if (data.code === 100000) {
            this.dialogVisible = false
            this.$emit('closeAddDialog')
            this.$message({
              type: 'success',
              message: data.msg,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }
    },
    goBack() {
      this.dialogVisible = false
      this.$emit('closeAddDialog')
    },
    del() {
      if (this.form.provincialExamination === '1') {
        if (this.userType !== '1')
          return this.$message.error('无权限删除省考标识知识点')
      }
      confirmMsg(
        '删除此知识点会导致关联的课件没有知识点，此操作不可逆，是否删除？',
        async () => {
          api.updateStatus(this.id).then(({ data }) => {
            if (data.code === 100000) {
              this.$message.success(data.msg)
              this.dialogVisible = false
              this.$emit('closeAddDialog')
            } else {
              this.$message.error(data.msg)
              this.$emit('closeAddDialog')
            }
          })
        }
      )
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') || '4'
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
<style>
.el-notification__content {
  text-align: center;
}
</style>
